var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSalesforceCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 32",
    role: "img",
    "aria-label": "Salesforce",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A1E0",
    d: "M10.6 4.2c1.1-2.3 3.5-3.9 6.2-3.9 1.8 0 3.4.7 4.6 1.9 1.1-.5 2.3-.8 3.6-.8 4.7 0 8.5 3.8 8.5 8.5 0 .4 0 .8-.1 1.2 2.4.9 4.1 3.2 4.1 5.9 0 3.5-2.8 6.3-6.3 6.3H8.8c-3.8 0-6.9-3.1-6.9-6.9 0-3.1 2-5.7 4.8-6.6-.3-.9-.4-1.8-.4-2.8 0-4.1 3.3-7.4 7.4-7.4 1.5 0 2.9.4 4.1 1.2-.8-1.5-2.4-2.5-4.2-2.5-2.6 0-4.8 1.7-5.5 4.1z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceCloud);
export default __webpack_public_path__ + "static/media/salesforce-cloud.634b77d95113c5f0922fb41b6dd57130.svg";
export { ForwardRef as ReactComponent };